/* ==========================================================================
   MANICH — Interaktiv Tennisarmbånd Guide
   Vanilla JavaScript. Ingen afhængigheder. Progressive enhancement:
   uden JS vises alle produkter som semantiske kort; med JS bliver kortene
   til en interaktiv vælger med stage-visning.
   Produktdata hardcodes IKKE her — alt læses fra DOM'en, som Shopify
   har renderet server-side ud fra produkter og metafelter.
   ========================================================================== */
(function () {
  'use strict';

  var CATEGORY_ORDER = ['classic', 'fancy', 'mixed'];
  var BUCKET_ORDER = ['1', '2', '3', '4', '5', '7', '10', '12plus'];

  function initRoot(root) {
    if (root.dataset.mtgReady === 'true') return;
    root.dataset.mtgReady = 'true';

    var items = Array.prototype.slice.call(
      root.querySelectorAll('.manich-tg__item')
    );
    if (!items.length) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.manich-tg__tab'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('.manich-tg__chip'));
    var stage = root.querySelector('.manich-tg__stage');
    var stageImg = root.querySelector('.manich-tg__stage-img');
    var details = root.querySelector('.manich-tg__details');
    var empty = root.querySelector('.manich-tg__empty');
    var hoverEnabled = root.dataset.hoverPreview === 'true';

    // Model bygget fra DOM
    var model = items.map(function (li, i) {
      return {
        el: li,
        card: li.querySelector('.manich-tg__card'),
        id: li.dataset.productId || String(i),
        category: (li.dataset.category || 'classic').trim(),
        bucket: (li.dataset.carat || '').trim(),
        name: li.dataset.name || '',
        image: li.dataset.image || '',
        index: i
      };
    });

    var state = {
      category: root.dataset.defaultCategory || firstPresent(model, 'category', CATEGORY_ORDER),
      bucket: null,
      activeId: null,
      previewId: null
    };

    /* ---------- Hjælpere ---------- */
    function firstPresent(list, key, order) {
      for (var i = 0; i < order.length; i++) {
        for (var j = 0; j < list.length; j++) {
          if (list[j][key] === order[i]) return order[i];
        }
      }
      return list.length ? list[0][key] : null;
    }

    function bucketsForCategory(cat) {
      var present = {};
      model.forEach(function (m) {
        if (m.category === cat && m.bucket) present[m.bucket] = true;
      });
      return BUCKET_ORDER.filter(function (b) { return present[b]; });
    }

    function matches(m) {
      return m.category === state.category &&
        (state.bucket === null || m.bucket === state.bucket);
    }

    /* ---------- Rendering ---------- */
    function syncTabs() {
      tabs.forEach(function (t) {
        var on = t.dataset.category === state.category;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
    }

    function syncChips() {
      var available = bucketsForCategory(state.category);
      chips.forEach(function (c) {
        var b = c.dataset.carat;
        var ok = available.indexOf(b) !== -1;
        c.disabled = !ok;
        c.setAttribute('aria-pressed', (ok && b === state.bucket) ? 'true' : 'false');
      });
    }

    function renderList() {
      var visible = [];
      model.forEach(function (m) {
        var show = matches(m);
        m.el.hidden = !show;
        m.el.classList.toggle('is-active', m.id === state.activeId);
        if (show) visible.push(m);
      });
      if (empty) empty.style.display = visible.length ? 'none' : 'block';
      return visible;
    }

    function setStage(m, isPreview) {
      if (!m || !stage || !stageImg) return;
      // Blødt skift af billede
      if (m.image && stageImg.getAttribute('src') !== m.image) {
        stage.classList.add('is-swapping');
        var next = new Image();
        next.onload = function () {
          stageImg.src = m.image;
          stageImg.alt = m.name;
          stage.classList.remove('is-swapping');
        };
        next.onerror = function () { stage.classList.remove('is-swapping'); };
        next.src = m.image;
      }
      renderDetails(m);
      if (!isPreview) {
        var tag = stage.querySelector('.manich-tg__stage-tag');
        if (tag) tag.textContent = caratLabel(m.bucket);
      }
    }

    function caratLabel(b) {
      return b === '12plus' ? '12+ ct' : (b ? b + ' ct' : '');
    }

    function renderDetails(m) {
      if (!details) return;
      var src = m.card;
      var name = src.querySelector('.manich-tg__card-name');
      var specDl = src.querySelector('.manich-tg__card-spec');
      var summary = src.getAttribute('data-summary') || '';
      var price = src.getAttribute('data-price') || '';
      var priceLabel = src.getAttribute('data-price-label') || '';
      var url = src.getAttribute('data-url') || '#';

      var html = '';
      html += '<h3 class="manich-tg__d-name">' + escapeHtml(m.name) + '</h3>';
      html += '<p class="manich-tg__d-carat">' + escapeHtml(caratLabel(m.bucket)) +
        ' &middot; ' + escapeHtml(categoryLabel(m.category)) + '</p>';
      if (specDl) {
        html += '<dl class="manich-tg__spec">' + specDl.innerHTML + '</dl>';
      }
      if (summary) {
        html += '<p class="manich-tg__summary">' + escapeHtml(summary) + '</p>';
      }
      if (price) {
        html += '<p class="manich-tg__price">' +
          (priceLabel ? '<small>' + escapeHtml(priceLabel) + '</small>' : '') +
          escapeHtml(price) + '</p>';
      }
      html += '<a class="manich-tg__cta" href="' + encodeURI(url) + '">' +
        (root.dataset.ctaLabel ? escapeHtml(root.dataset.ctaLabel) : 'Se armbåndet') +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
      details.innerHTML = html;
    }

    function categoryLabel(cat) {
      var t = tabs.filter(function (x) { return x.dataset.category === cat; })[0];
      return t ? t.textContent.trim() : cat;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* ---------- Vælg produkt ---------- */
    function selectFirstVisible() {
      var visible = model.filter(matches);
      state.activeId = visible.length ? visible[0].id : null;
      if (state.activeId) setStage(byId(state.activeId), false);
    }

    function byId(id) {
      for (var i = 0; i < model.length; i++) if (model[i].id === id) return model[i];
      return null;
    }

    function activate(m) {
      state.activeId = m.id;
      model.forEach(function (x) { x.el.classList.toggle('is-active', x.id === m.id); });
      setStage(m, false);
    }

    /* ---------- Handlinger ---------- */
    function setCategory(cat) {
      if (state.category === cat) return;
      state.category = cat;
      var available = bucketsForCategory(cat);
      state.bucket = available.length ? available[0] : null;
      syncTabs(); syncChips(); renderList(); selectFirstVisible();
    }

    function setBucket(b) {
      state.bucket = (state.bucket === b) ? null : b;
      syncChips(); renderList(); selectFirstVisible();
    }

    /* ---------- Event-binding ---------- */
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { setCategory(t.dataset.category); });
      t.addEventListener('keydown', function (e) {
        roving(e, tabs, i, function (n) { setCategory(tabs[n].dataset.category); tabs[n].focus(); });
      });
    });

    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { if (!c.disabled) setBucket(c.dataset.carat); });
      c.addEventListener('keydown', function (e) {
        roving(e, chips, i, function (n) { chips[n].focus(); });
      });
    });

    model.forEach(function (m) {
      if (!m.card) return;
      m.card.addEventListener('click', function (e) {
        // Lad rigtige links i kortet virke som normalt
        if (e.target.closest('a')) return;
        activate(m);
        if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      m.card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          if (e.target.closest('a')) return;
          e.preventDefault();
          activate(m);
        }
      });
      if (hoverEnabled && window.matchMedia('(hover: hover)').matches) {
        m.card.addEventListener('mouseenter', function () {
          if (m.hidden) return;
          state.previewId = m.id;
          setStage(m, true);
        });
        m.card.addEventListener('mouseleave', function () {
          state.previewId = null;
          var active = byId(state.activeId);
          if (active) setStage(active, false);
        });
      }
    });

    function roving(e, group, i, go) {
      var enabled = group.filter(function (g) { return !g.disabled; });
      var pos = enabled.indexOf(group[i]);
      if (pos === -1) return;
      var n = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (pos + 1) % enabled.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (pos - 1 + enabled.length) % enabled.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = enabled.length - 1;
      if (n === -1) return;
      e.preventDefault();
      go(group.indexOf(enabled[n]));
    }

    /* ---------- Init ---------- */
    root.classList.add('is-enhanced');
    var startBuckets = bucketsForCategory(state.category);
    state.bucket = startBuckets.length ? startBuckets[0] : null;
    syncTabs();
    syncChips();
    renderList();
    selectFirstVisible();
  }

  function boot() {
    document.querySelectorAll('.manich-tg[data-mtg]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor: re-init når sektionen genindlæses
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.manich-tg[data-mtg]');
    if (root) { root.dataset.mtgReady = 'false'; initRoot(root); }
  });
})();
